<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    老街站<br>
站点介绍<br>
老街站是3号线和1号线的换乘车站，位于罗湖区解放路与建设路相交汇处的东南角，在规划中的公交广场和解放路的地下, 地处东门商业区内，东侧为太宁路、太阳百货、东门步行街，西侧为老街四路、老街一路、港岛银座地下商场、深圳人民公园，南侧为门诊部、深圳市邮政局、中国银行深圳市分行，北侧为深圳戏院、工人文化宫，老街以淡黄色调为主色调。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:20	00:05	1号线	2分钟	4分40秒<br>
机场东	06:24	23:04	1号线	2分钟	4分40秒<br>
福保	06:17	23:51	3号线	2分15-20秒	4分30秒<br>
双龙	06:05	23:22	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:20	00:03	1号线	3分45秒	5分45秒<br>
机场东	06:23	23:03	1号线	3分45秒	5分45秒<br>
福保	06:26	23:51	3号线	3分15秒	5分钟<br>
双龙	06:07	23:21	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:20	01:03	1号线	3分45秒	5分45秒<br>
机场东	06:23	00:03	1号线	3分45秒	5分45秒<br>
福保	06:26	00:51	3号线	3分15秒	5分钟<br>
双龙	06:07	00:21	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
茂业百货（东门店）、南庆街、人民北路、永新路、文化公园<br><br>
B出入口:<br>
邮政大厦、市人民医院（第一门诊部）、深圳市中医院第三门诊部、建设路、和平路、深圳市供电局<br><br>
C出入口:<br>
迎春路、柠檬街、电信大厦<br><br>
D出入口:<br>
东门步行街、永新街<br><br>
E出入口:<br>
太阳百货<br><br>
F出入口:<br>
深圳戏院、新园路、迎宾东路<br><br>
G出入口:<br>
人民北路、桂园路、深圳市中医院第一门诊部、人民公园路、红桂中学、人民公园、工人文化宫<br><br>
H出入口:<br>
解放路（北）、人民公园路（北）<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 门诊部②西行方向<br>
103路 113路 12路 203路 214路 215路 3路 E8路 M156路 M190路 M192路 M559路 N3路<br><br>
B出入口:<br>
公交站名： 东行方向<br>
103路 113路 12路 203路 204路 204路快线 211路 214路 215路 337路 351路 3路 64路 E8路 M112路 M156路 M190路 M192路 M399路 M402路 M559路 N3路 N4路<br><br>
B出入口:<br>
公交站名： 人民桥<br>
104路 10路 12路 203路 204路 204路快线 214路 215路 223路 29路 337路 3路 64路 85路 M112路 M156路 M239路 M559路 N3路 N4路<br><br>
C出入口:<br>
公交站名： 门诊部①<br>
104路 104路快线 10路 223路 29路 85路 M133路 M191路 大鹏假日专线4路 高快巴士97路<br><br>
F出入口:<br>
公交站名： 深圳戏院<br>
M482路<br><br>
G出入口:<br>
公交站名： 中医院一门诊<br>
101路（过铁路桥，距离G出入口约300米）<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>












